export function mapClientFromApi(c) {
    if (!c) return null;
    const name = c.client_name || c.name || '';

    return {
        ...c,
        id: c.id,
        name,
        clientName: name,

        email: c.email ?? '',
        phone: c.phone ?? '',
        company: c.company ?? '',
        website: c.website ?? '',
        industry: c.industry ?? '',
        notes: c.notes ?? '',

        status: c.status || 'active',
        primaryContactId: c.primary_contact_id ?? c.primaryContactId ?? null,

        accountSite: c.account_site ?? c.accountSite ?? '',
        parentAccountId: c.parent_account_id ?? c.parentAccountId ?? null,
        accountNumber: c.account_number ?? c.accountNumber ?? '',
        accountType: c.account_type ?? c.accountType ?? '',
        rating: c.rating ?? '',
        fax: c.fax ?? '',
        ownership: c.ownership ?? '',
        employees: c.employees ?? 0,
        sicCode: c.sic_code ?? c.sicCode ?? '',
        annualRevenue: c.annual_revenue != null ? Number(c.annual_revenue)
            : (c.annualRevenue != null ? Number(c.annualRevenue) : 0),

        billingStreet: c.billing_street ?? c.billingStreet ?? '',
        billingCity: c.billing_city ?? c.billingCity ?? '',
        billingState: c.billing_state ?? c.billingState ?? '',
        billingCode: c.billing_code ?? c.billingCode ?? '',
        billingCountry: c.billing_country ?? c.billingCountry ?? '',

        shippingStreet: c.shipping_street ?? c.shippingStreet ?? '',
        shippingCity: c.shipping_city ?? c.shippingCity ?? '',
        shippingState: c.shipping_state ?? c.shippingState ?? '',
        shippingCode: c.shipping_code ?? c.shippingCode ?? '',
        shippingCountry: c.shipping_country ?? c.shippingCountry ?? '',

        leadSource: c.lead_source ?? c.leadSource ?? '',
        technologyStack: c.technology_stack ?? c.technologyStack ?? '',
        currentCms: c.current_cms ?? c.currentCms ?? '',
        currentEcommercePlatform: c.current_ecommerce_platform ?? c.currentEcommercePlatform ?? '',
        monthlyWebsiteTraffic: c.monthly_website_traffic ?? c.monthlyWebsiteTraffic ?? '',

        ownerUserId: c.owner_user_id ?? c.ownerUserId ?? null,
        ownerContactId: c.owner_contact_id ?? c.ownerContactId ?? null,
        estimatedProjectValue: c.estimated_project_value ?? c.estimatedProjectValue ?? 0,
        relationshipOwnerUserId: c.relationship_owner_user_id ?? c.relationshipOwnerUserId ?? null,
        lastContactDate: c.last_contact_date ?? c.lastContactDate ?? null,
        aiReadinessScore: c.ai_readiness_score ?? c.aiReadinessScore ?? null,
        seoAeoGeoOpportunity: c.seo_aeo_geo_opportunity ?? c.seoAeoGeoOpportunity ?? '',

        accountCommissionSplits: c.account_commission_splits ?? c.accountCommissionSplits ?? [] ,

        createdBy: c.created_by ?? c.createdBy ?? null,
        updatedBy: c.updated_by ?? c.updatedBy ?? null,
        createdAt: c.created_at ?? c.createdAt ?? null,
        updatedAt: c.updated_at ?? c.updatedAt ?? null
    };
}

export function mapClientToApi(client) {
    const raw = {
        client_name: client.name || client.client_name || client.clientName,
        email: client.email || undefined,
        phone: client.phone || undefined,
        company: client.company || undefined,
        website: client.website || undefined,
        industry: client.industry || undefined,
        notes: client.notes || undefined,
        status: client.status || undefined,
        account_type: client.accountType || client.account_type || undefined,
        rating: client.rating || undefined,
        fax: client.fax || undefined,
        ownership: client.ownership || undefined,
        employees: client.employees != null ? Number(client.employees) : undefined,
        sic_code: client.sicCode || client.sic_code || undefined,
        annual_revenue: client.annualRevenue != null && client.annualRevenue !== ''
            ? Number(client.annualRevenue)
            : undefined,
        account_site: client.accountSite || client.account_site || undefined,
        parent_account_id: client.parentAccountId || client.parent_account_id || undefined,
        account_number: client.accountNumber || client.account_number || undefined,
        owner_contact_id: client.ownerContactId || client.owner_contact_id || undefined,
        owner_user_id: client.ownerUserId || client.owner_user_id || undefined,
        primary_contact_id: client.primaryContactId || client.primary_contact_id || undefined,
        relationship_owner_user_id: client.relationshipOwnerUserId || client.relationship_owner_user_id || undefined,
        billing_street: client.billingStreet || client.billing_street || undefined,
        billing_city: client.billingCity || client.billing_city || undefined,
        billing_state: client.billingState || client.billing_state || undefined,
        billing_code: client.billingCode || client.billing_code || undefined,
        billing_country: client.billingCountry || client.billing_country || undefined,
        shipping_street: client.shippingStreet || client.shipping_street || undefined,
        shipping_city: client.shippingCity || client.shipping_city || undefined,
        shipping_state: client.shippingState || client.shipping_state || undefined,
        shipping_code: client.shippingCode || client.shipping_code || undefined,
        shipping_country: client.shippingCountry || client.shipping_country || undefined,
        lead_source: client.leadSource || client.lead_source || undefined,
        technology_stack: client.technologyStack || client.technology_stack || undefined,
        current_cms: client.currentCms || client.current_cms || undefined,
        current_ecommerce_platform: client.currentEcommercePlatform || client.current_ecommerce_platform || undefined,
        monthly_website_traffic: client.monthlyWebsiteTraffic || client.monthly_website_traffic || undefined,
        estimated_project_value: client.estimatedProjectValue != null ? Number(client.estimatedProjectValue) : undefined,
        last_contact_date: client.lastContactDate || client.last_contact_date || undefined,
        ai_readiness_score: client.aiReadinessScore != null ? Number(client.aiReadinessScore) : undefined,
        seo_aeo_geo_opportunity: client.seoAeoGeoOpportunity || client.seo_aeo_geo_opportunity || undefined,
    };
    const result = Object.fromEntries(Object.entries(raw).filter(([, v]) => v !== undefined && v !== null && v !== ''));
    result.parent_account_id = client.parentAccountId || client.parent_account_id || null;
    result.relationship_owner_user_id = client.relationshipOwnerUserId || client.relationship_owner_user_id || null;
    result.rating = client.rating || null;
    result.ownership = client.ownership || null;
    result.billing_state = client.billingState || client.billing_state || null;
    return result;
}

export function mapContactFromApi(c) {
    if (!c) return null;
    return {
        ...c,
        id: c.id,
        clientId: c.client_id || c.clientId || null,
        firstName: c.first_name || c.firstName || '',
        lastName: c.last_name || c.lastName || '',
        email: c.email || '',
        phone: c.phone || '',
        title: c.position || c.title || '',
        position: c.position || c.title || '',
        linkedIn: c.linkedin || c.linkedIn || c.linked_in || '',
        notes: c.notes || '',
        status: c.status || 'active',
        createdBy: c.created_by || c.createdBy || null,
        updatedBy: c.updated_by || c.updatedBy || null,
        createdAt: c.created_at || c.createdAt,
        updatedAt: c.updated_at || c.updatedAt
    };
}

export function mapContactToApi(contact, clientId) {
    const client_id = clientId !== undefined
        ? clientId
        : (contact.clientId !== undefined ? contact.clientId : (contact.client_id ?? null));
    const raw = {
        client_id,
        first_name: contact.firstName || contact.first_name,
        last_name: contact.lastName || contact.last_name || '',
        email: contact.email || undefined,
        phone: contact.phone || undefined,
        position: contact.title || contact.position || undefined,
        linkedin: contact.linkedIn || contact.linkedin || contact.linked_in || undefined,
        notes: contact.notes || undefined
    };
    const result = Object.fromEntries(Object.entries(raw).filter(([, v]) => v !== undefined && v !== null && v !== ''));
    // Always send client_id — API requires the field even when null
    result.client_id = client_id;
    return result;
}

/** Map UI pipeline stage keys to API enum values. */
export function normalizeStageToApi(stage) {
    if (stage === 'closed') return 'closed_won';
    if (stage === 'closedLost') return 'closed_lost';
    return stage || 'qualification';
}

/** Map API deal_stage values to UI pipeline keys. */
export function normalizeStageFromApi(stage) {
    if (stage === 'closed_won') return 'closed';
    if (stage === 'closed_lost') return 'closedLost';
    return stage || 'qualification';
}

export function mapDealFromApi(d) {
    if (!d) return null;
    const amount = Number(d.contract_value ?? d.contractValue ?? d.amount ?? 0);
    const prob = d.probability ?? 0;
    const dealStage = normalizeStageFromApi(d.deal_stage || d.dealStage);
    return {
        ...d,
        id: d.id,
        clientId: d.client_id || d.clientId,
        ownerUserId: d.owner_user_id || d.ownerUserId || null,
        primaryContactId: d.primary_contact_id || d.primaryContactId || null,
        referralContactId: d.referral_contact_id || d.referralContactId || null,
        dealName: d.deal_name || d.dealName || d.name,
        name: d.deal_name || d.dealName || d.name,
        description: d.description || '',
        notes: d.description || d.notes || '',
        probability: prob,
        contractValue: amount,
        amount,
        dealAmount: amount,
        dealStage,
        deal_stage: dealStage,
        status: d.status || 'open',
        pipelineId: d.pipeline_id || d.pipelineId || null,
        stageId: d.stage_id || d.stageId || null,
        dealPipeline: d.deal_pipeline || d.dealPipeline || 'digital_product',
        dealType: d.deal_type || d.dealType || '',
        leadSource: d.lead_source || d.leadSource || '',
        forecastCategory: d.forecast_category || d.forecastCategory || 'pipeline',
        serviceLine: d.service_line || d.serviceLine || '',
        engagementModel: d.engagement_model || d.engagementModel || '',
        nextSteps: Array.isArray(d.next_steps)
            ? d.next_steps
            : (Array.isArray(d.nextSteps) ? d.nextSteps : []),
        nextStep: d.next_step || d.nextStep || '',
        campaignSource: d.campaign_source || d.campaignSource || '',
        expectedCloseDate: d.expected_close_date || d.expectedCloseDate || '',
        lostReason: d.lost_reason || d.lostReason || '',
        lostReasonCategory: d.lost_reason_category || d.lostReasonCategory || '',
        sowSigningDate: d.sow_signing_date || d.sowSigningDate || '',
        originalCreatedDate: d.original_created_date || d.originalCreatedDate || d.deal_date || d.dealDate || '',
        dealDate: d.deal_date || d.dealDate || d.original_created_date || d.originalCreatedDate || '',
        actualCloseDate: d.actual_close_date || d.actualCloseDate || '',
        forecastProbability: d.forecast_probability ?? d.forecastProbability ?? null,
        version: d.version,
        deletedAt: d.deleted_at || d.deletedAt,
        createdBy: d.created_by || d.createdBy,
        updatedBy: d.updated_by || d.updatedBy || null,
        createdAt: d.created_at || d.createdAt,
        updatedAt: d.updated_at || d.updatedAt,
        forecastAmount: Math.round(amount * prob / 100),
        accountName: d.account_name || d.accountName || d.clientName || '',
        clientName: d.account_name || d.accountName || d.clientName || '',
        ownerName: d.owner_name || d.ownerName || '',
        dealOwner: d.owner_name || d.ownerName || d.dealOwner || '',
        primaryContactName: d.primary_contact_name || d.primaryContactName || '',
        createdByName: d.created_by_name || d.createdByName || '',
        updatedByName: d.updated_by_name || d.updatedByName || '',
        paymentTerms: d.payment_terms || d.paymentTerms || '',
        paymentModel: d.payment_model || d.paymentModel || '',
        invoiceFrequency: d.invoice_frequency || d.invoiceFrequency || '',
        invoiceAmount: d.invoice_amount != null ? Number(d.invoice_amount) : (d.invoiceAmount != null ? Number(d.invoiceAmount) : 0),
        paymentCount: d.total_invoices != null ? Number(d.total_invoices) : (d.paymentCount != null ? Number(d.paymentCount) : 0),
        taxIncluded: d.tax_enabled === true || d.taxEnabled === true || d.tax_enabled === 1,
        taxRate: d.tax_rate != null ? Number(d.tax_rate) : (d.taxRate != null ? Number(d.taxRate) : 0),
        taxAmount: d.tax_amount != null ? Number(d.tax_amount) : (d.taxAmount != null ? Number(d.taxAmount) : 0),
        totalWithTax: d.total_with_tax != null ? Number(d.total_with_tax) : (d.totalWithTax != null ? Number(d.totalWithTax) : 0),
        expectedFirstInvoiceDate: d.expected_first_invoice_date || d.expectedFirstInvoiceDate || '',
        lastInvoiceDate: d.last_invoice_date || d.lastInvoiceDate || '',
        revenueStartDate: d.revenue_start_date || d.revenueStartDate || '',
        revenueEndDate: d.revenue_end_date || d.revenueEndDate || '',
        scheduleDates: Array.isArray(d.schedule_dates)
            ? d.schedule_dates.filter(Boolean)
            : (Array.isArray(d.scheduleDates) ? d.scheduleDates.filter(Boolean) : []),
        stage_history: d.stage_history || d.stageHistory || [],
    };
}

function stripEmpty(obj) {
    return Object.fromEntries(Object.entries(obj).filter(([key, v]) => {
        // Strip undefined/null/empty strings only; keep 0 and false
        if (v === undefined || v === null || v === '') return false;
        return true;
    }));
}

export function mapDealToApi(deal, sessionUserId = null, { isUpdate = false } = {}) {
    const stage = normalizeStageToApi(deal.dealStage || deal.deal_stage || 'qualification');
    let status = deal.status || 'open';
    if (stage === 'closed_won') status = 'won';
    if (stage === 'closed_lost') status = 'lost';

    const payload = stripEmpty({
        deal_name: deal.dealName || deal.name || deal.deal_name,
        client_id: deal.clientId || deal.client_id,
        owner_user_id: deal.ownerUserId || deal.owner_user_id,
        primary_contact_id: Object.prototype.hasOwnProperty.call(deal, 'primaryContactId')
            ? (deal.primaryContactId || undefined)
            : (deal.primary_contact_id || undefined),
        description: deal.description || deal.notes,
        probability: deal.probability != null ? Number(deal.probability) : undefined,
        contract_value: Number(deal.contractValue ?? deal.dealAmount ?? deal.amount ?? 0),
        pipeline_id: deal.pipelineId || deal.pipeline_id,
        stage_id: deal.stageId || deal.stage_id,
        deal_pipeline: deal.dealPipeline || deal.deal_pipeline,
        deal_type: deal.dealType || deal.deal_type,
        lead_source: deal.leadSource || deal.lead_source,
        forecast_category: deal.forecastCategory || deal.forecast_category,
        service_line: deal.serviceLine || deal.service_line,
        engagement_model: deal.engagementModel || deal.engagement_model,
        next_step: deal.nextStep || deal.next_step,
        campaign_source: deal.campaignSource || deal.campaign_source,
        expected_close_date: deal.expectedCloseDate || deal.expected_close_date,
        lost_reason: deal.lostReason || deal.lost_reason,
        lost_reason_category: deal.lostReasonCategory || deal.lost_reason_category || deal.lost_reasonCategory,
        sow_signing_date: deal.sowSigningDate || deal.sow_signing_date,
        // Deal Date is the user-facing field; persist both aliases so updates stick.
        deal_date: deal.dealDate || deal.deal_date || deal.originalCreatedDate || deal.original_created_date,
        original_created_date: deal.dealDate || deal.deal_date || deal.originalCreatedDate || deal.original_created_date,
        payment_terms: deal.paymentTerms || deal.payment_terms,
        payment_model: deal.paymentModel || deal.payment_model,
        total_invoices: deal.paymentCount != null ? Number(deal.paymentCount) : (deal.totalInvoices != null ? Number(deal.totalInvoices) : undefined),
        invoice_frequency: deal.invoiceFrequency || deal.invoice_frequency,
        invoice_amount: deal.invoiceAmount != null ? Number(deal.invoiceAmount) : undefined,
    });

    payload.referral_contact_id = deal.referralContactId || deal.referral_contact_id || null;
    if (!payload.deal_pipeline) payload.deal_pipeline = 'digital_product';
    if (!payload.forecast_category) payload.forecast_category = 'pipeline';

    payload.deal_stage = stage;
    payload.status = status;
    if (isUpdate) {
        payload.version = Number(deal.version) || 1;
        if (sessionUserId) payload.updated_by = sessionUserId;
        payload.deal_type = deal.dealType || deal.deal_type || null;
        payload.lead_source = deal.leadSource || deal.lead_source || null;
        payload.service_line = deal.serviceLine || deal.service_line || null;
        payload.engagement_model = deal.engagementModel || deal.engagement_model || null;
        payload.pipeline_id = deal.pipelineId || deal.pipeline_id || null;
        payload.campaign_source = deal.campaignSource || deal.campaign_source || null;
    } else {
        payload.created_by = deal.createdBy || deal.created_by || sessionUserId;
    }

    return payload;
}

export function mapScheduleFromApi(s) {
    if (!s) return null;
    const amount = Number(s.amount ?? s.plannedAmount ?? 0);
    const status = s.status || 'planned';
    return {
        ...s,
        id: s.id,
        dealId: s.deal_id || s.dealId,
        invoiceCode: s.invoice_code || s.invoiceCode || null,
        scheduleName: s.schedule_name || s.scheduleName || '',
        plannedAmount: amount,
        amount,
        invoiceDate: s.due_date || s.invoiceDate || s.dueDate,
        dueDate: s.due_date || s.dueDate,
        plannedDate: s.planned_date || s.plannedDate || null,
        issuedDate: s.issued_date || s.issuedDate || null,
        status,
        paymentModel: s.payment_model || s.paymentModel,
        notes: s.notes || null,
        cancelReason: s.cancel_reason || s.cancelReason || null,
        paidAmount: status === 'paid' || status === 'partially_paid' ? amount : (s.paidAmount || 0),
        actualAmount: s.actual_amount || s.actualAmount || 0,
        dealName: s.deal_name || s.dealName || null,
        accountName: s.account_name || s.accountName || null,
        clientId: s.client_id || s.clientId || null,
        zohoInvoiceId: s.zoho_invoice_id || s.zohoInvoiceId || null,
        zohoStatus: s.zoho_status || s.zohoStatus || null,
        zohoAmountPaid: s.amount_paid ?? s.zohoAmountPaid ?? null,
        zohoBalanceDue: s.balance_due ?? s.zohoBalanceDue ?? null,
        zohoTotal: s.zoho_total ?? s.zohoTotal ?? null,
        zohoDueDate: s.zoho_due_date || s.zohoDueDate || null,
        zohoLastSyncedAt: s.zoho_last_synced_at || s.zohoLastSyncedAt || null,
        overdueDays: s.overdue_days ?? s.overdueDays ?? null,
    };
}

export function mapScheduleToApi(schedule) {
    const amount = schedule.plannedAmount ?? schedule.amount ?? 0;
    const numAmount = typeof amount === 'number' ? amount : Number(amount);
    return {
        schedule_name: schedule.scheduleName || schedule.schedule_name || schedule.milestoneTitle || 'Schedule',
        amount: numAmount,
        schedule_date: schedule.invoiceDate || schedule.due_date || schedule.dueDate,
        payment_model: schedule.paymentModel || schedule.payment_model || 'one_time',
        notes: schedule.notes || null
    };
}

export function mapGoalFromApi(g) {
    if (!g) return null;
    const start = g.start_date || g.startDate;
    const end = g.end_date || g.endDate;
    let year = g.year;
    let month = g.month || 0;
    if (!year && start) year = new Date(start).getFullYear();
    return {
        ...g,
        id: g.id,
        goalName: g.name || g.goalName || '',
        name: g.name || g.goalName || '',
        description: g.description || '',
        targetValue: Number(g.target_amount ?? g.targetValue ?? 0),
        achievedValue: Number(g.current_amount ?? g.achieved_value ?? g.achievedValue ?? 0),
        period: g.period || 'yearly',
        startDate: start,
        endDate: end,
        year: year || new Date().getFullYear(),
        month,
        quarter: g.quarter || 0,
        goalType: g.goal_type || g.goalType || 'revenue',
        userId: g.user_id ?? g.userId ?? null,
        scope: g.scope || (g.user_id ? 'user' : 'organization'),
        currency: g.currency || 'INR',
        unitType: g.unit_type || g.unitType || null,
        status: g.status || 'active',
        createdAt: g.created_at || g.createdAt,
        updatedAt: g.updated_at || g.updatedAt,
        createdBy: g.created_by ?? g.createdBy,
        updatedBy: g.updated_by ?? g.updatedBy
    };
}

export function mapGoalToApi(goal) {
    return {
        name: goal.goalName || goal.name,
        description: goal.description || null,
        target_amount: Number(goal.targetValue ?? goal.target_amount ?? 0),
        period: goal.period || 'yearly',
        start_date: goal.startDate || goal.start_date,
        end_date: goal.endDate || goal.end_date,
        user_id: goal.userId || goal.user_id || null,
        scope: goal.scope || 'user',
        goal_type: goal.goalType || goal.goal_type || 'revenue',
        currency: goal.currency || 'INR',
        unit_type: goal.unitType || goal.unit_type || 'count',
        status: goal.status || 'active'
    };
}

export function isDealContactPrimaryFlag(value) {
    if (value === true || value === 1) return true;
    if (value === false || value === 0 || value == null) return false;
    const normalized = String(value).trim().toLowerCase();
    return normalized === 'true' || normalized === '1' || normalized === 'yes' || normalized === 'on';
}

export function sameContactId(a, b) {
    if (a == null || b == null || a === '' || b === '') return false;
    return String(a).trim().toLowerCase() === String(b).trim().toLowerCase();
}

export function mapDealContactRoleFromApi(r) {
    if (!r) return null;
    const contactId = r.contact_id || r.contactId || '';
    if (!contactId) return null;
    return {
        id: r.id,
        contactId,
        role: r.role || 'business_user',
        isPrimary: isDealContactPrimaryFlag(r.is_primary ?? r.isPrimary),
        sortOrder: r.sort_order ?? r.sortOrder ?? 0
    };
}

export function mapDealContactRoleToApi(r, index = 0) {
    if (!r) return null;
    const contactId = r.contactId || r.contact_id;
    if (!contactId) return null;
    return {
        contact_id: contactId,
        role: r.role || 'business_user',
        is_primary: isDealContactPrimaryFlag(r.isPrimary ?? r.is_primary) ? 'true' : 'false',
        sort_order: r.sortOrder != null ? Number(r.sortOrder) : index
    };
}

export function mapCommissionSplitFromApi(s) {
    if (!s) return null;
    const userId = s.user_id || s.userId || '';
    // Ignore legacy contact-only recipients — commissions are users only.
    if (!userId) return null;
    return {
        id: s.id,
        userId,
        contactId: '',
        recipientType: 'user',
        role: (s.role && s.role !== 'contact') ? s.role : 'sales_executive',
        splitPct: Number(s.split_pct ?? s.splitPct ?? 0),
        isInheritedFromAccount: s.is_inherited_from_account === true
            || s.is_inherited_from_account === 'true'
            || s.isInheritedFromAccount === true,
        relation: s.relation || null,
    };
}

export function mapCommissionSplitToApi(s) {
    if (!s) return null;
    const userId = s.userId || s.user_id;
    // Contacts are no longer accepted as commission recipients.
    if (!userId) return null;
    return {
        role: (s.role && s.role !== 'contact') ? s.role : 'sales_executive',
        split_pct: String(s.splitPct ?? s.split_pct ?? 0),
        is_inherited_from_account: s.isInheritedFromAccount || s.is_inherited_from_account
            ? 'true'
            : 'false',
        user_id: userId,
        relation: s.relation || null,
    };
}

export function mapCommissionFromApi(c) {
    if (!c) return null;
    return {
        ...c,
        id: c.id,
        dealId: c.deal_id || c.dealId,
        scheduleId: c.schedule_id || c.scheduleId,
        ownerUserId: c.user_id || c.ownerUserId || c.userId || null,
        userId: c.user_id || c.userId || null,
        contactId: c.contact_id || c.contactId || null,
        amount: Number(c.amount ?? 0),
        status: c.status || 'pending',
        relation: c.relation || null,
        paidDate: c.paid_date || c.paidDate || c.paid_at || c.paidAt || null,
        payoutDate: c.payout_date || c.payoutDate || null,
        rate: c.rate != null ? Number(c.rate) : null,
        notes: c.notes || null,
        createdAt: c.created_at || c.createdAt || null,
        updatedAt: c.updated_at || c.updatedAt || null
    };
}

export function mapCommissionToApi(row) {
    if (!row) return null;
    return {
        deal_id: row.dealId || row.deal_id,
        schedule_id: row.scheduleId || row.schedule_id || null,
        user_id: row.ownerUserId || row.userId || row.user_id || null,
        amount: Number(row.amount ?? 0),
        status: row.status || 'pending',
        relation: row.relation || null,
        paid_date: row.paidDate || row.paid_date || null,
        rate: row.rate != null ? Number(row.rate) : null,
        notes: row.notes || null
    };
}

export function mapUserFromApi(u) {
    if (!u) return null;
    return {
        ...u,
        id: u.id,
        name: u.full_name || u.name || '',
        fullName: u.full_name || u.name || '',
        email: u.email || '',
        phone: u.phone || '',
        role: u.role || '',
        status: (u.is_active === false || u.is_active === 'inactive') ? 'inactive' : (u.status || 'active'),
        department: u.department || '',
        designation: u.designation || '',
        workLocation: u.work_location || '',
        managerUserId: u.manager_user_id || null,
        isCommissionEligible: u.is_commission_eligible !== 'false',
        // Avatar metadata only — binary fetched via GET /users/{id}/avatar
        hasAvatar: u.has_avatar === true,
        avatarMimeType: u.avatar_mime_type || null,
        avatarUpdatedAt: u.avatar_updated_at || null,
        avatarUrl: u.avatar_url || (u.has_avatar ? `/api/v1/users/${u.id}/avatar` : ''),
        // Never hydrate password from API responses into client models
        password: '',
        createdBy: u.created_by || null,
        createdAt: u.created_at || u.createdAt,
        updatedAt: u.updated_at || u.updatedAt
    };
}

export function mapUserToApi(user, { includePassword = true } = {}) {
    const payload = {
        email: user.email,
        full_name: user.name || user.fullName,
        phone: user.phone || '',
        role: user.role || 'viewer',
        department: user.department || '',
        designation: user.designation || '',
        work_location: user.workLocation || '',
        manager_user_id: user.managerUserId || null,
        is_commission_eligible: user.isCommissionEligible === false ? 'false' : 'true'
    };
    if (includePassword && user.password) payload.password = user.password;
    if (user.status) payload.is_active = user.status === 'inactive' ? 'inactive' : 'active';
    // Only drop truly-absent keys. Emptied (null/'') optional fields MUST be
    // sent so the API can clear them — stripping them silently keeps the old value.
    return Object.fromEntries(Object.entries(payload).filter(([, v]) => v !== undefined));
}

export function mapActivityFromApi(a) {
    if (!a) return null;
    const dealId = a.deal_id || a.dealId;
    const clientId = a.client_id || a.clientId;
    const entityType = dealId ? 'deal' : (clientId ? 'client' : (a.entity_type || a.entityType));
    const entityId = dealId || clientId || a.entity_id || a.entityId;
    return {
        ...a,
        id: a.id,
        entityType,
        entityId,
        dealId,
        clientId,
        contactId: a.contact_id || a.contactId,
        type: a.activity_type || a.type,
        activityType: a.activity_type || a.type,
        subject: a.subject || '',
        body: a.description || a.body || '',
        description: a.description || a.body || '',
        mentions: a.mentions ?? null,
        dueDate: a.due_date || a.dueDate,
        userId: a.user_id || a.userId || a.created_by || a.createdBy,
        createdBy: a.created_by || a.createdBy || a.user_id || a.userId,
        createdAt: a.created_at || a.createdAt,
        updatedAt: a.updated_at || a.updatedAt,
        source: a.source || null,
        isInternal: a.is_internal === true || a.isInternal === true || a.is_internal === 'true' || a.isInternal === 'true' || a.is_internal === 1,
        isEditable: a.is_editable !== false,
        editedAt: a.edited_at || a.editedAt || null,
        deletedAt: a.deleted_at || a.deletedAt || null,
        deletedBy: a.deleted_by || a.deletedBy || null,
        deletedByName: a.deleted_by_name || a.deletedByName || a.deleted_by || a.deletedBy || null,
        parentActivityId: a.parent_activity_id || a.parentActivityId || null
    };
}

export function mapActivityToApi(activity) {
    const payload = {
        activity_type: activity.type || activity.activityType || 'note',
        subject: activity.subject || '',
        description: activity.body || activity.description || null,
        due_date: activity.dueDate || activity.due_date || null,
        entity_type: activity.entityType || activity.entity_type || null,
        entity_id: activity.entityId || activity.entity_id || null
    };
    if (activity.dealId || activity.entityType === 'deal') {
        payload.deal_id = activity.dealId || activity.entityId;
    }
    if (activity.clientId || activity.entityType === 'client') {
        payload.client_id = activity.clientId || activity.entityId;
    }
    if (activity.contactId) payload.contact_id = activity.contactId;
    if (Array.isArray(activity.mentions)) payload.mentions = activity.mentions;
    if (activity.isInternal !== undefined) payload.is_internal = activity.isInternal;
    return payload;
}

export function mapPipelineFromApi(p) {
    if (!p) return null;
    return {
        ...p,
        id: p.id,
        name: p.name || '',
        description: p.description || '',
        isDefault: p.is_default || p.isDefault || 'false',
        isActive: p.is_active || p.isActive || 'true',
        stages: (p.stages || []).map(mapPipelineStageFromApi),
        createdAt: p.created_at || p.createdAt,
        updatedAt: p.updated_at || p.updatedAt
    };
}

export function mapPipelineToApi(pipeline) {
    return {
        name: pipeline.name,
        description: pipeline.description || null,
        is_default: pipeline.isDefault || pipeline.is_default || 'false',
        is_active: pipeline.isActive || pipeline.is_active || 'true'
    };
}

export function mapPipelineStageFromApi(s) {
    if (!s) return null;
    return {
        ...s,
        id: s.id,
        pipelineId: s.pipeline_id || s.pipelineId,
        stageName: s.stage_name || s.stageName || '',
        stageOrder: s.stage_order ?? s.stageOrder ?? 0,
        defaultProbability: s.default_probability || s.defaultProbability || '0',
        isClosed: s.is_closed || s.isClosed || 'false',
        isWon: s.is_won || s.isWon || 'false'
    };
}

export function mapPipelineStageToApi(stage) {
    return {
        stage_name: stage.stageName || stage.stage_name,
        stage_order: stage.stageOrder ?? stage.stage_order ?? 0,
        default_probability: stage.defaultProbability || stage.default_probability || '0',
        is_closed: stage.isClosed || stage.is_closed || 'false',
        is_won: stage.isWon || stage.is_won || 'false'
    };
}

export function mapProductFromApi(p) {
    if (!p) return null;
    return {
        ...p,
        id: p.id,
        name: p.name || '',
        code: p.code || '',
        serviceLine: p.service_line || p.serviceLine || '',
        isActive: p.is_active || p.isActive || 'true',
        createdAt: p.created_at || p.createdAt,
        updatedAt: p.updated_at || p.updatedAt
    };
}

export function mapProductToApi(product) {
    return {
        name: product.name,
        code: product.code || null,
        service_line: product.serviceLine || product.service_line || null,
        is_active: product.isActive || product.is_active || 'true'
    };
}

export function mapDealLineItemFromApi(item) {
    if (!item) return null;
    return {
        ...item,
        id: item.id,
        dealId: item.deal_id || item.dealId,
        productId: item.product_id || item.productId || null,
        quantity: item.quantity || 1,
        unitPrice: Number(item.unit_price ?? item.unitPrice ?? 0),
        discount: Number(item.discount ?? 0),
        totalAmount: Number(item.total_amount ?? item.totalAmount ?? 0)
    };
}

export function mapDealLineItemToApi(item) {
    return {
        product_id: item.productId || item.product_id || null,
        quantity: item.quantity || 1,
        unit_price: Number(item.unitPrice ?? item.unit_price ?? 0),
        discount: Number(item.discount ?? 0),
        total_amount: Number(item.totalAmount ?? item.total_amount ?? 0)
    };
}

export function mapDealTeamMemberFromApi(m) {
    if (!m) return null;
    return {
        ...m,
        id: m.id,
        dealId: m.deal_id || m.dealId,
        userId: m.user_id || m.userId,
        role: m.role || ''
    };
}

export function mapDealTeamMemberToApi(member) {
    return {
        user_id: member.userId || member.user_id,
        role: member.role
    };
}

export function mapForecastSnapshotFromApi(s) {
    if (!s) return null;
    return {
        ...s,
        id: s.id,
        dealId: s.deal_id || s.dealId,
        forecastAmount: Number(s.forecast_amount ?? s.forecastAmount ?? 0),
        probability: s.probability || '0',
        forecastCategory: s.forecast_category || s.forecastCategory || 'pipeline',
        snapshotDate: s.snapshot_date || s.snapshotDate || ''
    };
}

export function mapForecastSnapshotToApi(snapshot) {
    return {
        forecast_amount: Number(snapshot.forecastAmount ?? snapshot.forecast_amount ?? 0),
        probability: snapshot.probability || '0',
        forecast_category: snapshot.forecastCategory || snapshot.forecast_category || 'pipeline',
        snapshot_date: snapshot.snapshotDate || snapshot.snapshot_date
    };
}

export function mapDealNextStepFromApi(s) {
    if (!s) return null;
    return {
        ...s,
        id: s.id,
        dealId: s.deal_id || s.dealId,
        action: s.action || '',
        dueDate: s.due_date || s.dueDate || '',
        status: s.is_completed === 'true' ? 'completed' : 'pending',
        sortOrder: s.sort_order ?? s.sortOrder ?? 0,
        createdAt: s.created_at || s.createdAt,
        updatedAt: s.updated_at || s.updatedAt
    };
}

export function mapDealNextStepToApi(step) {
    return {
        action: step.action,
        due_date: step.dueDate || step.due_date || null,
        is_completed: step.status === 'completed' ? 'true' : 'false',
        sort_order: step.sortOrder ?? step.sort_order ?? 0
    };
}
